import { useLocalSearchParams } from 'expo-router';

import { DirectDepositSwitch } from '../../../../banking/components/direct-deposit/DirectDepositSwitch';
import type { DirectDepositSwitchAppContext } from '../../../../banking/components/direct-deposit/types';

const Switch = () => {
    const { context, source } = useLocalSearchParams<{
        context?: DirectDepositSwitchAppContext;
        source?: string;
    }>();
    return <DirectDepositSwitch context={context} source={source} />;
};

export default Switch;
